import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { IndicatorsService } from '../../../../../services/indicators/indicators.service';
import { isUndefined } from 'util';
import { Point } from '../../../../../models/pointWidget.model';


@Component({
  selector: 'app-spesa-media-carta-indicator',
  templateUrl: './spesa-media-carta-indicator.component.html',
  styleUrls: ['./spesa-media-carta-indicator.component.css']
})
export class SpesaMediaCartaIndicatorComponent implements OnInit, OnChanges {

  @Input() data: any;

  pointData: Point;


  constructor(private indicatorService: IndicatorsService) {

  }

  ngOnInit() {
    if (!isUndefined(this.data)) {
      this.indicatorService.indicatorCalculation('SpesaMediaCarta', this.data).subscribe((res) => {
       this.pointData = res[0];
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!isUndefined(changes['data'].currentValue)) {
      this.ngOnInit();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/widgets/value/spesa-media-carta-indicator/spesa-media-carta-indicator.component.ts